<template>
  <div>
    <div class="row mb-3 align-end pr-1">
      <div class="col-6">
        <AlertBadge
          :alert="electrode.hasWarning"
          style="max-width: 8rem; padding-right: .75rem"
        >
          <ElectrodeLifetime
            :value="electrode.remaining"
            :color="color"
          />
        </AlertBadge>
      </div>
    </div>
    <div
      class="mb-3"
    >
      <h2 class="pb-0h" :style="{ color: color }">{{ $t('consumables.electrode.production') }}</h2>
      <div class="pb-0h consumption">
        <span class="large-text">
          {{ round(electrode.weekChlorineProduction, 2) }}
        </span>
        &ensp;{{ electrode.suffix }}/{{ $t('common.unit.week.singular') }}
      </div>
      <ConsumptionHistoryLabels
        :data-series="electrode.dataSeries"
        :color="color"
      />
    </div>
  </div>
</template>

<script setup>
import AlertBadge from '@acs/components-library/src/components/common/AlertBadge.vue';
import ConsumptionHistoryLabels from '@acs/components-library/src/components/deviceDetail/diagrams/ConsumptionHistoryLabels.vue';
import ElectrodeLifetime from '@acs/components-library/src/components/deviceDetail/diagrams/ElectrodeLifetime.vue';

import { useMath } from '@acs/components-library/src/composables/Math.js';
import { toRefs, defineProps } from 'vue';
const { round } = useMath();

const props = defineProps({
  color: {
    type: String,
    required: true,
  },
  electrode: {
    type: Object,
    required: true,
  },
});

const { color, electrode } = toRefs(props);

</script>

<style lang="scss" scoped>
.btn.local {
  height: 2.5rem;
  cursor: initial;
}
span.large-text {
  font-size: 1.5rem;
  line-height: 1.5rem;
}
span.medium-text {
  font-size: 1rem;
  line-height: 1.5rem;
}

.consumption {
  text-transform: lowercase;
}
</style>
